import * as R from 'ramda';
import React, { Fragment } from 'react';
// forms
import { Fieldset2 } from '../../../../forms/formik';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
import { ENUMS } from '../../../../constants/enums';
import { intervalUomOptions, equipmentServiceStatusOptions } from '../../../../helpers/options';
// ui
import { Box } from '../../../../ui';
//////////////////////////////////////////////////

const fieldsWrapperStyles = { mb: 30, width: '100%' };

const inputWrapperStyles = { mr: 15, flexGrow: 1, flexBasis: 110 };

const inputWrapperStyles2 = { flexGrow: 1, flexBasis: 110 };

const getDisabled = (_, values) => G.isAllNilOrEmpty(
  R.values(R.pick([GC.FIELD_TRUCK_GUID, GC.FIELD_TRAILER_GUID], R.or(values, {}))),
);

const fieldsetSettings = [
  {
    fieldsWrapperStyles,
    fields: [
      {
        inputWrapperStyles,
        type: 'reactSelect',
        options: 'templates',
        shouldCustomChange: true,
        fieldName: GC.FIELD_TEMPLATE_ID,
        label: ['titles:template', 'Template'],
        customChangeHandler: (value, _, { values, templates, setValues, setFieldValue }) => {
          if (R.isNil(value)) return setFieldValue(GC.FIELD_TEMPLATE_ID, null);

          const template = R.find(R.propEq(value, GC.FIELD_GUID), templates);

          const {
            fees,
            parts,
            labors,
            currency,
            intervalUom,
            intervalCount,
            serviceVendorGuid,
            serviceType: { dropdownOptionGuid } = {},
          } = template;

          const estimates =
            R.and(G.isNotNilAndNotEmpty(serviceVendorGuid), G.isOneNotNilOrNotEmpty([fees, parts, labors])) ? [{
              [GC.FIELD_CURRENCY]: currency,
              [GC.FIELD_SERVICE_VENDOR_GUID]: serviceVendorGuid,
              [GC.FIELD_FEES]: R.map(G.omitObjectSystemFields, R.or(fees, [])),
              [GC.FIELD_PARTS]: R.map(G.omitObjectSystemFields, R.or(parts, [])),
              [GC.FIELD_LABORS]: R.map(G.omitObjectSystemFields, R.or(labors, [])),
            }] : [];

          return setValues({
            ...values,
            [GC.FIELD_TEMPLATE_ID]: value,
            [GC.FIELD_INTERVAL]: intervalCount,
            [GC.FIELD_INTERVAL_UOM]: intervalUom,
            [GC.FIELD_SERVICE_TYPE]: dropdownOptionGuid,
            [GC.FIELD_SERVICE_VENDOR_ESTIMATES]: estimates,
            [GC.FIELD_SERVICE_VENDOR_GUID]: serviceVendorGuid,
          });
        },
      },
      {
        type: 'reactSelect',
        disabled: getDisabled,
        fieldName: GC.FIELD_STATUS,
        label: ['titles:status', 'Status'],
        options: equipmentServiceStatusOptions,
        inputWrapperStyles: inputWrapperStyles2,
      },
    ],
  },
  {
    fieldsWrapperStyles,
    fields: [
      {
        type: 'text',
        isRequired: true,
        inputWrapperStyles,
        inputStyles: { pr: 15 },
        fieldName: GC.FIELD_SERVICE_ID,
        label: ['titles:service-id', 'Service ID'],
      },
      {
        isRequired: true,
        isClearable: true,
        type: 'datePicker',
        inputWrapperStyles,
        fieldName: GC.FIELD_SERVICE_DATE,
        label: ['titles:planned-service-date', 'Planned Service Date'],
      },
      {
        type: 'select',
        isRequired: true,
        withClickZIndex: true,
        fieldName: GC.FIELD_SERVICE_TYPE,
        options: 'equipmentServiceTypeOptions',
        inputWrapperStyles: inputWrapperStyles2,
        label: ['titles:service-type', 'Service Type'],
      },
    ],
  },
  {
    fieldsWrapperStyles,
    fields: [
      {
        type: 'text',
        inputWrapperStyles,
        fieldName: GC.FIELD_APPROVED_BY,
        label: ['titles:approved-by', 'Approved By'],
      },
      {
        inputWrapperStyles,
        type: 'reactSelect',
        options: 'userGeneralListFullNameOptions',
        fieldName: GC.FIELD_APPROVED_BY_USER_GUID,
        label: ['titles:approved-by-user', 'Approved By User'],
      },
      {
        isMulti: true,
        type: 'reactSelect',
        disabled: getDisabled,
        fieldName: GC.FIELD_COMPONENT_GUIDS,
        options: 'availableForServiceEquipmentComponents',
        inputWrapperStyles: { mr: 0, flexGrow: 1, flexBasis: 110 },
        label: ['titles:equipment-components', 'Equipment Components'],
      },
    ],
  },
  {
    fieldsWrapperStyles,
    fields: [
      {
        type: 'number',
        inputWrapperStyles,
        fieldName: GC.FIELD_INTERVAL,
        label: ['titles:interval', 'Interval'],
      },
      {
        type: 'select',
        fieldName: GC.FIELD_INTERVAL_UOM,
        inputWrapperStyles: inputWrapperStyles2,
        label: ['titles:interval-uom', 'Interval UOM'],
        options: G.addEmptyOptionToDropDown(intervalUomOptions),
      },
      {
        type: 'text',
        fieldName: GC.FIELD_ODOMETER,
        label: ['titles:odometer', 'Odometer'],
        inputWrapperStyles: {
          ...inputWrapperStyles2,
          ml: 15,
          display: (props) => G.ifElse(
            R.isNotNil(R.path(['values', GC.FIELD_TRAILER_GUID], props)),
            'none',
          ),
        },
      },
    ],
  },
  {
    fieldsWrapperStyles,
    fields: [
      {
        isClearable: true,
        type: 'datePicker',
        inputWrapperStyles,
        shouldCustomChange: true,
        fieldName: GC.FIELD_PERFORMED_DATE,
        label: ['titles:performed-date', 'Performed Date'],
        customChangeHandler2: ({ value, props }) => {
          const { values, setValues } = props;

          const { status } = values;

          const performedDate = G.convertInstanceToDefaultDateFormat(value);

          const newStatus = G.ifElse(
            R.and(G.isValidDate(performedDate), G.notEquals(status, ENUMS.ENUM_COMPLETED)),
            ENUMS.ENUM_COMPLETED,
            status,
          );

          setValues({
            ...values,
            performedDate,
            [GC.FIELD_STATUS]: newStatus,
          });
        },
      },
      {
        type: 'number',
        inputWrapperStyles,
        fieldName: GC.FIELD_PERFORMED_VALUE,
        label: ['titles:performed-value', 'Performed Value'],
      },
      {
        type: 'select',
        fieldName: GC.FIELD_PERFORMED_TYPE,
        inputWrapperStyles: inputWrapperStyles2,
        label: ['titles:performed-type', 'Performed Type'],
        options: [
          GC.EMPTY_OPTION_OBJECT,
          { value: GC.UOM_HOURS, label: G.getUomLocale(GC.UOM_HOURS) },
          { value: GC.UOM_MILES, label: G.getUomLocale(GC.UOM_MILES) },
          { value: GC.UOM_KILOMETERS, label: G.getUomLocale(GC.UOM_KILOMETERS) },
        ],
      },
    ],
  },
  {
    fieldsWrapperStyles: { width: '100%' },
    fields: [
      {
        type: 'textarea',
        inputStyles: {
          p: 15,
          height: 100,
        },
        inputWrapperStyles: {
          flexGrow: 1,
          flexBasis: 300,
        },
        fieldName: GC.FIELD_COMMENTS,
        label: ['titles:comments', 'Comments'],
      },
    ],
  },
];

const ServiceForm = (props) => {
  const {
    templates,
    equipmentServiceTypeOptions,
    userGeneralListFullNameOptions,
    availableForServiceEquipmentComponents,
  } = props;

  return (
    <Fragment>
      <Box p={15}>
        <Fieldset2
          {...G.getFormikProps(props)}
          grouped={true}
          templates={templates}
          fields={fieldsetSettings}
          equipmentServiceTypeOptions={equipmentServiceTypeOptions}
          userGeneralListFullNameOptions={userGeneralListFullNameOptions}
          availableForServiceEquipmentComponents={availableForServiceEquipmentComponents}
        />
      </Box>
    </Fragment>
  );
};

export default ServiceForm;
